import { call, spawn } from 'redux-saga/effects'
import createDocumentSaga from 'sagas/createDocumentSaga'
import offlineProjectTitle from 'sagas/setupProjectsSaga/offlineProjectTitle'
import initialProject from 'helpers/projects/initialProject'
import getProjectsAndSettings from 'sagas/setupProjectsSaga/getProjectsAndSettings'
import deferApplyProjects from 'sagas/setupProjectsSaga/deferApplyProjects'

export default function * handleProjectsAndSettings(offlineProject, model) {
  const { settings, project, projectsLength } = yield call(getProjectsAndSettings, model)

  if (projectsLength === 0) {
    const project = offlineProject || initialProject()
    const idAndRev = yield call(createDocumentSaga, project)
    return { project: { ...project, ...idAndRev }, settings }
  } else if (offlineProject) {
    const project = { ...offlineProject, title: offlineProjectTitle(offlineProject.title, projectsLength) }
    const idAndRev = yield call(createDocumentSaga, project)

    // don't get the just created project
    yield spawn(deferApplyProjects, idAndRev._id)
    return { project: { ...project, ...idAndRev }, settings }
  } else {
    yield spawn(deferApplyProjects, project._id)
    return { project, settings }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/handleProjectsAndSettings.js